export default __webpack_public_path__ + "static/media/envsensor_realtime_light.8bcd3691.svg";